var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "ItpBox",
        { staticClass: "items-spacing w-100", attrs: { alignItems: "center" } },
        [
          _c(
            "ItpBox",
            { attrs: { direction: "column" } },
            [
              _c("ItpText", { staticClass: "mb-0", attrs: { muted: "" } }, [
                _vm._v("\n      " + _vm._s(_vm.resourceTitle) + "\n    ")
              ]),
              _vm._v(" "),
              _c("ItpText", {
                staticClass: "mb-0",
                attrs: { tag: "h4", text: _vm.resourceKey }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("UcInvoiceTypeBadge", {
            attrs: {
              value: _vm.invoice.invoice_type,
              kind: _vm.invoice.invoice_kind,
              advance: _vm.invoice.is_advance
            }
          }),
          _vm._v(" "),
          _c("UcInvoiceStatusBadge", { attrs: { value: _vm.invoice.status } }),
          _vm._v(" "),
          _vm.invoice.tags && _vm.invoice.tags.length
            ? _c(
                "DIV",
                _vm._l(_vm.invoice.tags, function(tag) {
                  return _c(
                    "span",
                    { staticClass: "badge badge-secondary mx-1 shadow-none" },
                    [_vm._v("\n      " + _vm._s(tag) + "\n    ")]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.invoice.isReadOnly
            ? _c(
                "DIV",
                { attrs: { title: _vm._f("gettext")("Closed") } },
                [_c("ItpIcon", { attrs: { icon: _vm.$config.lockIcon } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.invoice.authority_transaction_id
            ? _c(
                "DIV",
                { staticClass: "text-green-500" },
                [
                  _c(
                    "DIV",
                    { attrs: { title: _vm.invoice.authority_transaction_id } },
                    [
                      _c("ItpIcon", {
                        attrs: { icon: "fluent:cloud-sync-complete-16-regular" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "DIV",
                    {
                      attrs: {
                        title: JSON.stringify(
                          _vm.invoice.authority_transaction_status
                        )
                      }
                    },
                    [_c("ItpIcon", { attrs: { icon: "fa-question-circle" } })],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.invoice.reference_invoice
            ? _c(
                "ItpBox",
                { attrs: { direction: "column" } },
                [
                  _c("ItpText", { staticClass: "mb-0", attrs: { muted: "" } }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm._f("pgettext")("Reference invoice", "Invoice")
                        ) +
                        "\n    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("UcInvoiceMiniCard", {
                    attrs: {
                      item: _vm.invoice.reference_invoice,
                      "no-icon": ""
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.invoice.referencing_invoices &&
          _vm.invoice.referencing_invoices.length
            ? _c(
                "ItpBox",
                { attrs: { direction: "column" } },
                [
                  _c("ItpText", { staticClass: "mb-0", attrs: { muted: "" } }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm._f("pgettext")("Referencing invoices", "Invoice")
                        ) +
                        "\n    "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "ItpBox",
                    _vm._l(_vm.invoice.referencing_invoices, function(obj) {
                      return _c("UcInvoiceMiniCard", {
                        key: obj.id,
                        staticClass: "mr-2",
                        attrs: { item: obj, "no-icon": "" }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.invoice.isNew
            ? _c("Icon", {
                attrs: {
                  icon: "flagpack:" + _vm.invoice.language,
                  title: _vm._f("pgettext")("Invoice Language", "Invoice")
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "DIV",
            { staticClass: "btn-toolbar ml-auto flex-nowrap" },
            [
              _vm.invoice.meta &&
              _vm.invoice.meta.issuance_status.status == "not_started"
                ? _c("BtnIssueInvoice", {
                    staticClass: "ml-auto mr-2",
                    attrs: { invoice: _vm.invoice },
                    on: {
                      success: function($event) {
                        return _vm.evh_3573211234170528_success($event, {})
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.invoice.meta &&
              _vm.invoice.meta.billing_service_status.status == "not_started"
                ? _c("BtnSyncInvoice", {
                    staticClass: "ml-auto mr-2",
                    attrs: { invoice: _vm.invoice },
                    on: {
                      success: function($event) {
                        return _vm.evh_3350181908999980_success($event, {})
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.invoice.meta &&
              (_vm.invoice.meta.data_reporting_status.status == "not_started" ||
                _vm.invoice.meta.data_reporting_status.status == "error")
                ? _c("BtnReportInvoiceData", {
                    staticClass: "ml-auto mr-2",
                    attrs: { resource: _vm.invoice },
                    on: {
                      success: function($event) {
                        return _vm.evh_5626515103939381_success($event, {})
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.invoice.meta &&
              _vm.invoice.meta.sync_to_external_system_status.status ==
                "not_started"
                ? _c("BtnSyncResource", {
                    staticClass: "ml-auto mr-2",
                    attrs: {
                      resource: _vm.invoice,
                      target: "irent",
                      confirmMessage:
                        "A számlát csak egyszer lehet felölteni a régi rendszerbe,\nfeltöltés után a számlát már nem lehet módosítani."
                    },
                    on: {
                      success: function($event) {
                        return _vm.evh_5072463219534047_success($event, {})
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.invoice.isNew && !_vm.invoice.isReadOnly
                ? _c("ItpButton", {
                    staticClass: "ml-auto mr-2",
                    attrs: {
                      icon: _vm.$config.editIcon,
                      tooltip: _vm._f("gettext")("Edit"),
                      variant: "light"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.evh_5450657804282831_clickPreventStop(
                          $event,
                          {}
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.invoice.isNew
                ? _c("ItpButton", {
                    staticClass: "ml-auto mr-2",
                    attrs: {
                      icon: "fa-sync-alt",
                      tooltip: _vm._f("gettext")("Reload"),
                      spinning: _vm.actions.reload.isRunning,
                      variant: "light"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.evh_995920279152457_clickPreventStop(
                          $event,
                          {}
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("UcInvoiceViewDocumentDropdown", {
                staticClass: "ml-auto mr-2",
                attrs: { invoice: _vm.invoice },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_8434031504612555_clickPreventStop($event, {})
                  }
                }
              }),
              _vm._v(" "),
              _vm.invoice.preview_url
                ? _c("ItpButton", {
                    staticClass: "ml-auto mr-2",
                    attrs: {
                      variant: "light",
                      icon: "icon-park-outline:preview-open",
                      href: _vm.invoice.preview_url,
                      tooltip: _vm._f("pgettext")("Open preview", "Invoice"),
                      target: "_blank",
                      "use-auth": "",
                      "show-spinner": ""
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.invoice.log_messages
                ? _c("ItpButton", {
                    staticClass: "ml-auto mr-2",
                    attrs: {
                      variant: "light",
                      icon: "icon-park-outline:log",
                      tooltip: _vm._f("pgettext")(
                        "Show log messages",
                        "Invoice"
                      )
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.evh_1246756660686207_clickPreventStop(
                          $event,
                          {}
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.invoice.isNew
                ? _c(
                    "b-dropdown",
                    {
                      staticClass: "border",
                      attrs: { right: "", variant: "light", "no-caret": "" }
                    },
                    [
                      _c("ItpIcon", {
                        staticClass: "mx-1",
                        attrs: { slot: "button-content", fa: "bars" },
                        slot: "button-content"
                      }),
                      _vm._v(" "),
                      _vm.invoiceIsRegistrable
                        ? _c("ItpButton", {
                            attrs: {
                              "dropdown-item": "",
                              text: _vm._f("pgettext")(
                                "Register invoice",
                                "Invoice"
                              ),
                              tooltip: _vm._f("pgettext")(
                                "Add this invoice to the invoice register",
                                "Invoice"
                              ),
                              variant: "default"
                            },
                            on: {
                              click: function($event) {
                                return _vm.evh_932298791746317_click($event, {})
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("ItpButton", {
                        attrs: {
                          "dropdown-item": "",
                          text: _vm._f("pgettext")("Copy", "BtnCopyResource"),
                          tooltip: _vm._f("pgettext")(
                            "Create new invoice from this one",
                            "Invoice"
                          ),
                          variant: "default"
                        },
                        on: {
                          click: function($event) {
                            return _vm.evh_2674698048827991_click($event, {})
                          }
                        }
                      }),
                      _vm._v(" "),
                      !_vm.invoice.isNew
                        ? _c("ItpButton", {
                            attrs: {
                              "dropdown-item": "",
                              text: _vm._f("pgettext")(
                                "Create pass-through",
                                "Invoice"
                              ),
                              tooltip: _vm.messages.createPassThroughTooltip,
                              variant: "default",
                              disabled: !_vm.invoicePassThroughIsEnabled
                            },
                            on: {
                              click: function($event) {
                                return _vm.evh_2252498968068653_click(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.invoice.isNew
                        ? _c("ItpButton", {
                            attrs: {
                              "dropdown-item": "",
                              text: _vm._f("pgettext")(
                                "Create advance",
                                "Invoice"
                              ),
                              tooltip: _vm.messages.createAdvanceInvoiceTooltip,
                              variant: "default",
                              disabled: !_vm.canCreateAdvanceInvoice
                            },
                            on: {
                              click: function($event) {
                                return _vm.evh_3512640571721973_click(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.invoice.isNew
                        ? _c("ItpButton", {
                            attrs: {
                              "dropdown-item": "",
                              text: _vm._f("pgettext")(
                                "Create final",
                                "Invoice"
                              ),
                              tooltip: _vm.messages.createFinalInvoiceTooltip,
                              variant: "default",
                              disabled: !_vm.canCreateFinalInvoice
                            },
                            on: {
                              click: function($event) {
                                return _vm.evh_6424219584985303_click(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      !_vm.invoice.isNew
                        ? _c("ItpButton", {
                            attrs: {
                              "dropdown-item": "",
                              text: _vm._f("pgettext")(
                                "Create storno",
                                "Invoice"
                              ),
                              tooltip: _vm.createStornoTooltip,
                              variant: "default",
                              disabled: !_vm.invoiceIsReversible
                            },
                            on: {
                              click: function($event) {
                                return _vm.evh_6886333622481462_click(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.invoice.isNew
                        ? _c("ItpButton", {
                            attrs: {
                              "dropdown-item": "",
                              variant: "default",
                              text: _vm._f("pgettext")(
                                "Create corrector",
                                "Invoice"
                              ),
                              tooltip: _vm.createCorrectorTooltip,
                              disabled: !_vm.invoiceIsModifiable
                            },
                            on: {
                              click: function($event) {
                                return _vm.evh_6074864154397733_click(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.invoice.isNew && !_vm.invoice.isReadOnly
                        ? _c("BtnLockResource", {
                            attrs: {
                              "no-icon": "",
                              "dropdown-item": "",
                              resource: _vm.invoice,
                              tooltip: _vm._f("pgettext")(
                                "Lock invoice",
                                "Invoice"
                              )
                            },
                            on: {
                              success: function($event) {
                                return _vm.evh_8797352275194556_success(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.invoice.isNew && !_vm.invoice.isReadOnly
                        ? _c("BtnDeleteResource", {
                            attrs: {
                              "no-icon": "",
                              "dropdown-item": "",
                              resource: _vm.invoice,
                              tooltip: _vm._f("pgettext")(
                                "Delete invoice",
                                "Invoice"
                              )
                            },
                            on: {
                              success: function($event) {
                                return _vm.evh_6679522740328543_success(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("ItpButton", {
                        attrs: {
                          "dropdown-item": "",
                          text: _vm._f("pgettext")(
                            "History",
                            "BtnResourceHistory"
                          ),
                          tooltip: _vm._f("pgettext")(
                            "Invoice history",
                            "Invoice"
                          ),
                          variant: "default"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.evh_4848747000340100_clickPreventStop(
                              $event,
                              {}
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }